module.exports = __webpack_public_path__ + "static/media/photo135.408236d5.jpg";